export const getId = (idPrefix: string = '', name: string = '') =>
  idPrefix ? idPrefix + name : null;

export const calculateWidth = (totalPages: number) =>
  `${totalPages.toString().length}em`;

export const upperCaseFirst = (str: string): string =>
  str[0].toUpperCase() + str.slice(1);
